
import { Component, Input, Output, OnChanges, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';

import { ConvertDatePipe } from '../../filters/convert-date/convert-date.pipe';
import { SpanTooltipComponent } from '../span-tooltip/span-tooltip.component';
import { NgClass } from '@angular/common';
import { ContextFactory } from '@shared/factories/context/context.factory';
import { AfTranslateDirective } from '@shared/modules/translate/directive/af-translate.directive';
import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';
import { ButtonWithMenuActionComponent } from '../button-with-menu-action/button-with-menu-action.component';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { LoaderFactory } from '@shared/factories/loader/loader.factory';
import { UserPermisionsFactory } from '@shared/factories/user-permisions/user-permisions.factory';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import { RegisterMixtapeService } from '@shared/services/register-mixpanel/register-mixtape.service';
import { from } from 'rxjs';


@Component({
  selector: 'states-process',
  templateUrl: './states-process.component.html',
  standalone: true,
  imports: [
    NgClass,
    SpanTooltipComponent,
    ConvertDatePipe,
    AfTranslateDirective,
    ButtonWithMenuActionComponent
  ]
})
export class StatesProcessComponent implements OnChanges {
  skin: string = this.globalCfg.skin;
  isLanding: Boolean = this.customLanding.isLanding();
  evaluationId: any = this.route.snapshot.params['evaluationId'];
  previewView: boolean = location.pathname.indexOf('preview-customization') !== -1;
  statesProcess:any = {
    prevStateListItem: {
      keyName: 'state',
      expandedMenu: []
    },
    nextStateListItem: {
      keyName: 'state',
      expandedMenu: []
    },
    statesList: [],
    prevStateList: [],
    showStates: false,
    canChangeState: false,
    canAddAlerts: false,
    showAll: false,
    maxStatesShowed: 3,
    summary:{
      current: {}
    },
    userId: this.context.user.userId? (this.context.user.userId + 'U').toString() : (this.context.user.contactId + 'C').toString()
  }

  constructor(private context: ContextFactory,
    private globalCfg: GlobalCfgFactory,
    private loader: LoaderFactory,
    private customLanding: CustomLandingFactory,
    private translate: AfTranslateFactory,
    private userPermisions: UserPermisionsFactory,
    private route: ActivatedRoute,
    private apiService: ApiServiceService,
    private commonUtilsService: CommonUtilsService,
    private modalService: ModalServiceService,
    private registerService: RegisterMixtapeService
    ) {
  }

  @Input() type:any = null;
  @Input() item:any = null;
  @Input() concept:any = null;
  @Input() userPublic:any = null;
  @Input() typeView:string = 'normal';

  @Output() changeResponsible:any = new EventEmitter();
  @Output() changeState:any = new EventEmitter();
  @Output() changeLockedEdit:any = new EventEmitter();
  @Output() changeStateModal:any = new EventEmitter();

  ngOnChanges(): void {
    let that: any = this.statesProcess;
    that.item = this.item;
    if(this.concept){
      that.userPermissions = this.concept?.conceptObjectId === 'viewEdit'?'none': this.userPermisions.getPermissions();
      that.concept = this.concept;
    }
    if(this.type){
      this.configureByType(this.type);
    }
  }

  configureByType(type:string){
    let that: any = this.statesProcess;
    if (type === 'normalTask') {
      this.configureStatesTaskInit();
    } else {
      this.configureVM(that.concept.processStates);
    }
  }

  changeProcessQuestion(itemSelected:any, option:any){
    if(!this.previewView){
      let processTaskResponsibles: any = this.statesProcess.summary.current.processTaskResponsibles;
      if(option === 'task'){
        let typeButtons: string = itemSelected.nextState?'advance':'goBack';
        this.modalService.infoModal({text: this.translate.instant('states-process.question-task-confirm'), typeButtons: typeButtons})
          .subscribe((result:any)=>{
            if(result.result === 'ok'){
              this.statesProcess.itemSelected = itemSelected;
              this.confirmChange();
            }
          })
      }else if(this.typeView === 'changeStateModal'){
        this.changeStateModal.emit({
          state:{
            current: this.statesProcess.summary,
            itemSelected: itemSelected,
            option:option
          }
        })
      }else if(this.type !== 'normalTask' && this.statesProcess.summary && this.statesProcess.concept.shareUrl !== null && processTaskResponsibles.length && this.commonUtilsService.checkResponsibles( this.statesProcess.summary.current.processTaskResponsibles,  this.context.user.userId)){
        this.modalService.warningModal({ text: this.translate.instant('states-process.not-responsible'), typeButtons: 'cancelContinue' })
          .subscribe((result:any)=>{
            if(result.result !== 'cancel'){
              this.changeProcess(itemSelected, option);
            }
          })
      }else{
        this.changeProcess(itemSelected, option);
      }
    }
  }

  showProcessModal(){
    let that: any = this.statesProcess;
    let configuration: any;
    if(this.type === 'normalTask'){
      this.modalService.statesTaskHelp();
    }else{
      let registerItem ={
        event:'open process',
        conceptName: sessionStorage.getItem('breadcrumbConcept') + this.concept.title,
        processName: this.concept.processStates.current.name
      }
      this.registerService.register(registerItem);
      // let evaluationId = this.evaluationId && !this.item.evaluationId? this.evaluationId : this.item.evaluationId;
      if( this.type === 'processConcept' && this.isLanding){
         configuration = {
          evaluationId: this.evaluationId && !this.item.evaluationId? this.evaluationId : this.item.evaluationId,
          concept: this.concept,
          canAddAlerts: false,
          canAddTask: false,
          preview: true,
          hideDates: true
        }
      } else {
        configuration = {
          evaluationId: this.evaluationId && !this.item.evaluationId? this.evaluationId : this.item.evaluationId,
          concept: this.concept,
          conceptObjectId: this.item.conceptObjectId,
          canChangeState: that.canChangeState,
          canAddAlerts: that.canAddAlerts,
          canAddTask: false,
          preview: !that.canChangeState,
          summary:  that.summary,
          isLanding: this.isLanding
        }
      }

      this.modalService.processModal(configuration)
        .subscribe((result:any)=>{
          this.getProcess();
        })
    }
  }

  changeProcess(itemSelected:any, option:any){
    let that: any = this.statesProcess;
    that.itemSelected = itemSelected;
    that.direction = option;
    let typeButtons: string = option === 'next'?'advance':'goBack';
    let text: string = itemSelected.archiveConceptObject?this.translate.instant('states-process.change-state-advice-archived'):this.translate.instant('states-process.change-state-advice');
    this.modalService.infoModal({ text: text, typeButtons: typeButtons })
      .subscribe((result:any)=>{
        if(result.result === 'ok'){
          this.confirmChange();
        }
      })
  }

  confirmChange(){
    if (this.type === 'normalTask') {
      this.changeStates();
    } else {
      this.type === 'processConcept' && this.globalCfg.skin === 'icam-red' && this.concept.conceptNamedKey === 'Consulta'
        ? this.checkShowInfoModal()
        : this.changeStateProcess();
    }
  }

  configureStatesTaskInit(){
    this.statesProcess.taskSelectState = {
      taskStateId: this.item.taskStateId,
      state: this.item.state,
      stateActive: true
    }
    this.getTaskStates(false);
  }

  getTaskStates(saveForm:any = false){
    this.apiService.get('tasks/states', this.item.taskStateId)
      .then((data:any)=>{
        this.statesProcess.statesList = data;
        this.statesProcess.statesList.push(this.statesProcess.taskSelectState);
        this.statesProcess.statesList.sort(this.orderList);
        this.configureColorStates();
        this.checkPermissions();
        this.getState();
        if(saveForm){
          this.saveForm();
        }
      }, (errorData:any)=>{
        this.loader.closeError();
        this.modalService.errorModal({ text: this.translate.instant('states-process.error-states') });
      });
  }

  orderList(a:any, b:any) {
    return a.taskStateId - b.taskStateId;
  }

  getState(){
    let stateIdSelected:number = 0;
    let statesList: any = this.statesProcess.statesList;
    this.statesProcess.prevStateList = [];
    this.statesProcess.nextStateListItem.expandedMenu = [];
    this.statesProcess.prevStateListItem.expandedMenu = [];
    statesList.forEach((state:any) => {
      state.nextState = false;
      state.prevState = false;
      if(state.stateActive){
        state.stateStep = this.translate.instant('states-process.actual-state');
        stateIdSelected = state.taskStateId;
      }else if(stateIdSelected && stateIdSelected < state.taskStateId){
        state.stateStep = this.translate.instant('states-process.next-state');
        state.nextState = true;
      }else{
        state.stateStep = this.translate.instant('states-process.prev-state');
        state.prevState = true;
      }
      state.disabled = state.disabledState;
      state.nextState
        ? this.statesProcess.nextStateListItem.expandedMenu.push(state)
        : this.statesProcess.prevStateList.push(state);
    });
    if (this.statesProcess?.prevStateList[0]) {
      this.statesProcess.prevStateListItem.expandedMenu.push(this.statesProcess.prevStateList[0]);
    }
  }

  configureColorStates(){
    let statesList: any = this.statesProcess.statesList;
    statesList.forEach((state:any) => {
      switch(state.taskStateId){
        case 1:
          state.stateType = 'open';
          break;
        case 2:
          state.stateType = 'stand-by';
          break;
        case 3:
          state.stateType = 'progress';
          break;
        case 4:
          state.stateType = 'resolved';
          break;
        case 5:
          state.stateType = 'closed';
          break;
        default:
          state.stateType = 'closed-unresolved';
          break;
      }
    })
  }

  checkPermissions(){
    let taskTypeId: any = this.item.taskTypeId;
    let statesList: any = this.statesProcess.statesList;
    if (this.item && (taskTypeId === 1 || taskTypeId === 3 || taskTypeId === 6 || taskTypeId === 7 )){
      if(this.isLanding){
        statesList.forEach((state:any) => {
          this.disabledState(state)
        })
      } else{
        if(this.checkParticipants()){
          statesList.forEach((state:any) => {
            this.disabledState(state)
          })
        }else if(this.item.createdUserId === this.context.user.userId){
          statesList.forEach((state:any) => {
            if(this.statesProcess.userPermissions === 'none'){
              state.disabledState = true;
            }else if(state.taskStateId === 5 || state.taskStateId === 6){
              state.disabledState = (state.taskStateId === 1 || state.taskStateId === 5 || state.taskStateId === 6) && state.taskStateId === this.statesProcess.taskSelectState.taskStateId;
            }else{
              state.disabledState = true;
            }
          })
        }else{
          statesList.forEach((state:any) => {
            state.disabledState = true;
          })
        }
      }
      this.statesProcess.showStates = true;
    }
  }

  disabledState(state:any){
    if(this.statesProcess.userPermissions === 'none'){
      state.disabledState = true;
    }else if(state.taskStateId !== 5 && state.taskStateId !== 6){
      state.disabledState = Boolean((state.taskStateId === 1 || state.taskStateId === 4 ) && state.taskStateId === this.statesProcess.taskSelectState.taskStateId);
    }else if(!this.isLanding && this.item.createdUserId === this.context.user.userId && this.statesProcess.typeParticipant === 'U'){
      state.disabledState = false;
    }else{
      state.disabledState = true;
    }
  }

  saveForm(){
    let htmlContent: any = {
      taskId: this.statesProcess.item.taskId,
      htmlContent: $('.concept-form').html()
    }
    this.apiService.patch('tasks/savepdf', this.item.taskId, htmlContent)
      .then((data:any)=>{
        this.changeState.emit({task: this.item});
        this.loader.closeLoader(['task-state-save-form']);
        this.modalService.successModal({text: this.translate.instant('states-process.not-personalized-ok')})
      }, (errorData:any)=>{
        this.loader.closeError();
        this.modalService.errorModal({ text: this.translate.instant('common.error-generate-pdf') });
      })
  }

  configureVM(data: any) {
    let that: any = this.statesProcess;
    that.summary = data;
    that.showStates = true;
    if (this.userPublic || (this.concept && this.concept.conceptObjectId === 'view')) {
      that.canChangeState = false;
      that.canAddAlerts = false;
    } else if (this.type === 'processConcept') {
      that.canChangeState = that.userPermissions && that.userPermissions !== 'none';
      that.canAddAlerts = that.userPermissions !== 'none' && !!this.context.user.userId;
    } else if (this.type === 'processTask') {
      that.canChangeState = that.userPermissions !== 'none';// && (child.item.createdUserId === this.context.user.userId || this.checkParticipants(child));
    }
    this.configureSteps(that.summary?.previous, that.summary.next);
    this.concept.processStates = that.summary;
  }

  configureSteps(previous: any, next: any = []){
    let that: any = this.statesProcess;
    that.prevStateListItem.keyName = 'stateName';
    that.nextStateListItem.keyName = 'stateName';
    that.prevStateListItem.expandedMenu = [];
    that.nextStateListItem.expandedMenu = [];
    if (previous) {
      previous.disabled = !that.canChangeState;
      that.prevStateListItem.expandedMenu.push(previous);
    }
    next.forEach((nextItem: any) => {
      nextItem.disabled = !that.canChangeState;
      that.nextStateListItem.expandedMenu.push(nextItem);
    });
  }

  addOrUndoTransition(apiCall:any, personzalizedNotification: boolean){
    let that: any = this.statesProcess
    apiCall.then((data:any)=>{
      if (data && data.current) {
        if (this.changeResponsible && (this.type === 'processTask' || this.type === 'processConcept') && that.itemSelected.responsible && this.commonUtilsService.checkResponsibles( that.summary.current.processTaskResponsibles,  that.itemSelected.responsible.responsibleId)) {
          this.changeResponsible.emit({ responsible: that.itemSelected.responsible });
        }
        this.modifyLockedEdit(data.current.stateLockedEdit);
        this.configureVM(data);
        this.configureAlertsHours();
        this.closeLoaderTransition(personzalizedNotification);
      }
    }, (errorData:any)=>{
      this.apiError(errorData);
    });
  }

  modifyLockedEdit(lockedEdit:any){
    if(!this.isLanding && this.type === 'processConcept' && lockedEdit !== this.concept.stateLockedEdit){
      this.changeLockedEdit.emit({ lockedEdit: lockedEdit });
    }
  }

  closeLoaderTransition(personzalizedNotification: boolean) {
    this.loader.closeLoader(['add-undo-transition']);
    this.modalService.successModal({
      text: personzalizedNotification
        ? this.translate.instant('states-process.personalized-notification-ok')
        : this.translate.instant('states-process.not-personalized-ok')
    });
  }

  configureAlertsHours(){
    let concept: any = this.statesProcess.concept;
    if(concept.conceptNamedKey === 'Consulta'){
      if(concept.processStates.current.stateId0 > 3){
        concept.tooltipAlertHour = this.translate.instant('concept-tab.concept-finished');
        concept.textAlertHour = this.translate.instant('concept-instances-list.finished');
        concept.stepIsFinal = true;
      }else{
        concept.tooltipAlertHour = this.translate.instant('concept-tab.hours').replace('{hours}', concept.processingHours);
        concept.textAlertHour = concept.processingHours +' '+ this.translate.instant('add-alert.hours');
        concept.stepIsFinal = false;
      }
      this.commonUtilsService.configureAlertState(concept);
    }
   }

  apiError(err:any) {
    let that: any = this.statesProcess;
    that.view = 'result';
    that.error = true;
    let errorText:string = this.translate.instant('common.unexpected-error');
    if(this.globalCfg.skin === 'icam-red' && that.concept.conceptNamedKey === 'Consulta' && err && err.description && err.description.message && err.description.alertType && this.isLanding){
      err.description.alertType === 'Internal'? console.log(err.description.message) : errorText = err.description.message;
    }else if (err && err.status === 409) {
      errorText = this.translate.instant('process.conflict-error-text');
    }
    this.loader.closeError();
    this.modalService.errorModal({ text: errorText });
  }

  checkParticipants(){
    let that: any = this.statesProcess
    if(that.item.participants){
      for(let i : number = 0; i < that.item.participants.length; i++){
        let participant: any = that.item.participants[i];
        let idParticipant:any = !participant.id? participant.listValueId : participant.id;
        let id = (idParticipant + participant.type).toString();
        if(id === this.statesProcess.userId){
          that.typeParticipant = participant.type;
          return true;
        }
     }
    }
    return false;
  }

  changeStates() {
    let that: any = this.statesProcess
    if (that.item.taskTypeId !== 2 && that.item.taskTypeId !== 7 && that.taskSelectState.taskStateId !== that.itemSelected.taskStateId){
      this.loader.openLoader('task-state-save-form')
      this.saveTaskState(that.itemSelected);
    }
  }

  saveTaskState(selectState:any){
    let that: any = this.statesProcess;
    that.item.taskStateId = selectState.taskStateId;
    that.item.state = selectState.state;
    that.taskNew =  {
      taskStateId: selectState.taskStateId,
      taskId: that.item.taskId
    };
    this.apiService.patch('tasks/changestate', that.taskNew.taskId, that.taskNew)
      .then((data:any) => {
        that.taskSelectState = selectState;
        that.taskSelectState.stateActive = true;
        this.getTaskStates(true);
      }, (errorData:any)=>{
        this.loader.closeError();
        this.modalService.errorModal({ text: this.translate.instant('states-process.error-change-states') });
      })
  }

  checkShowInfoModal(){
    let that: any = this.statesProcess;
    let documentation: any = that.concept.documentation;
    let fieldsSearch:any = this.getFieldQuery();
    if(fieldsSearch.typeQuery === 1 && that.itemSelected.stateId0 === 10 && (!documentation || (documentation && documentation.totalDocuments === 0))){
      this.showInfoDocumentModal();
    }else if(fieldsSearch.typeQuery === 2 && that.itemSelected.stateId0 === 4 && fieldsSearch.digitizationDocument){
      this.checkDocuments(fieldsSearch.digitizationDocument);
    }else{
      this.changeStateProcess();
    }
  }

  getFieldQuery(){
    let fieldsSearch:any = {
      typeQuery: null,
      digitizationDocument: null
    }

    this.statesProcess.concept.evaluatedFields.forEach((field:any) => {
      if(field.fieldId0 === 10){
        if(field.floatvalue){
          field.listValues.forEach((listValue:any) => {
            if(listValue.listValueId === field.floatvalue){
              fieldsSearch.typeQuery = listValue.numOrder;
            }
          })
        }
      }else if(field.fieldId0 === 348){
        fieldsSearch.digitizationDocument = field.floatvalue;
      }
    });
    return fieldsSearch;
  }

  checkDocuments(conceptObjectId:any){
    this.apiService.get('documentobjects/'+ conceptObjectId +'/count')
      .then((data:any) => {
        data === 0? this.showInfoDocumentModal() : this.changeStateProcess();
      }, (errorData:any)=>{});
  }

  showInfoDocumentModal(){
    this.modalService.infoModal({ text: this.translate.instant('states-process.no-associated-files') })
      .subscribe((result:any)=>{
        if(result.result ==='ok'){
          this.changeStateProcess();
        }
      })
  }

  changeStateProcess(){
    let that: any = this.statesProcess;
    let state:any = {
      transitionId: that.itemSelected.transitionId
    }
    let omitAlertCustom = that.direction === 'previous' && this.globalCfg.skin === 'icam-red';
    if (that.itemSelected && that.itemSelected.hasAlertCustom && !omitAlertCustom) {
      this.modalService.personzalizedNotificationModal(that.concept, that.itemSelected)
        .subscribe((result:any)=>{
          if(result.result ==='ok'){
            this.loader.openLoader('add-undo-transition');
            state.customBody = result.customEmail.customBody;
            state.customSubject = result.customEmail.customSubject;
            this.configureTransition(state, true, that.itemSelected.stateName);
          }
        })
    }else{
      this.loader.openLoader('add-undo-transition');
      this.configureTransition(state, false, that.itemSelected.stateName);
    }
  }

  configureTransition(state: any, personzalizedNotification: boolean, stepName: any) {
    let that: any = this.statesProcess;
    let callApi = that.direction === 'next'
      ? this.apiService.add(`processesdata/${that.item.conceptObjectId}`, state)
      : this.apiService.delete(`processesdata/${that.item.conceptObjectId}/last/${state.transitionId}`, state);
    let type = that.direction === 'next' ? "Advance process" : "Back process";
    this.registerService.register({
      event: type,
      stepName: stepName,
      conceptName: sessionStorage.getItem('breadcrumbConcept') + that.concept.title,
      processName: that.concept.processStates.next.name
    });
    this.addOrUndoTransition(callApi, personzalizedNotification);
  }

  getProcess(){
    let that: any = this.statesProcess;
    this.apiService.getWithTranslate('processesdata/'+ that.concept.conceptObjectId, 'summary')
      .then((data:any)=> {
        that.concept.processStates = data;
        this.configureByType(this.type);
      }, ()=>{});
  }
}
